import React from 'react';
const HomeFurnishing = () => <div className="service-page"><h1>Home Furnishing</h1><p>Quality home furnishing solutions for every style.</p></div>;
export default HomeFurnishing;
